import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './App.css';
import Header from './components/Header';
import Home from './pages/Home';
import Match from './pages/Match';
import Account from './pages/Account';
import Support from './pages/Support';
import About from './pages/About';
import Terms from './pages/Terms';
import CheckoutSuccess from './pages/CheckoutSuccess';
import ScrimTracks from './pages/ScrimTracks';
import Scrims from './pages/Scrims';
import CreateScrim from './pages/CreateScrim';
import Scrim from './pages/Scrim';
import { getStoredThemePreference, setTheme } from './utils/theme';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
    mutations: {
      retry: 1,
    },
  },
});

function App() {
  // Initialize theme with stored preference
  useEffect(() => {
    const theme = getStoredThemePreference();
    setTheme(theme);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="App">
          <div className="header">
            <Header />
          </div>
          <div className="content-container">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/match/:match_id" element={<Match />} />
              <Route path="/match/:match_id/:map_index" element={<Match />} />
              <Route path="/match/:match_id/:map_index/:round_number" element={<Match />} />
              <Route path="/account" element={<Account />} />
              <Route path="/support" element={<Support />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/checkout_success" element={<CheckoutSuccess />} />
              <Route path="/scrims" element={<Scrims />} />
              <Route path="/scrim/:scrim_id" element={<ScrimTracks />} />
              <Route path="/scrim/:scrim_id/replay" element={<Scrim />} />
              <Route path="/create-scrim" element={<CreateScrim />} />
            </Routes>
          </div>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
